<template>
	<div class="ps">
		<div v-if="totalPages > FIRST_PAGE" class="ps__elm">
			<div class="ps__elm-label">Страниц</div>

			<!-- SELECT -->
			<div class="ps__elm-select" @focusout="onFocusOut" tabindex="0">
				<!-- Selected value -->
				<div class="ps__elm-select-wrap" @click="onClick">
					<div class="ps__elm-select-wrap-num">{{ currentPage }}</div>
					<div class="ps__elm-select-wrap-icon">
						<IconChevron />
					</div>
				</div>

				<!-- Dropdown -->
				<div v-if="isShow" class="ps__elm-select-list">
					<div v-for="page in totalPages" :key="page">
						<div
							:class="
								page === currentPage
									? 'ps__elm-select-list-item_current'
									: 'ps__elm-select-list-item'
							"
							@click="onClickSelect(page)"
						>
							{{ page }}
						</div>
					</div>
				</div>
			</div>
			<div class="ps__elm-total">из {{ totalPages }}</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconChevron from "@/components/icons/IconChevron.vue";

@Options({
	components: { IconChevron },
	props: {
		totalPages: { type: Number, default: 1 },
		currentPage: { type: Number, default: 1 },
	},
})
export default class PageSelect extends Vue {
	public totalPages: number;
	public currentPage: number;
	public isShow = false;

	public FIRST_PAGE = 1;

	/**
	 * Показываем/скрываем выпадающий список
	 */
	public onClick() {
		this.isShow = !this.isShow;
	}

	/**
	 * Выбор значения из выпадающего списка
	 * @param page
	 */
	public onClickSelect(page: number) {
		this.isShow = !this.isShow;
		this.$emit("selected-page", page);
	}

	/**
	 * Скрываем выпадающий список, если кликнули за его пределами
	 */
	public onFocusOut() {
		this.isShow = false;
	}
}
</script>

<style scoped lang="scss">
.ps {
	user-select: none;

	&__overlay {
		display: block;
		position: fixed;
		z-index: 1;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow: auto;
	}

	&__elm {
		display: flex;
		padding: 12px 24px;
		align-items: center;
	}

	&__elm-label {
		margin-right: 10px;
		font-size: 14px;
		font-weight: 600;
		color: rgb(51, 51, 51);
	}

	&__elm-total {
		color: rgb(51, 51, 51);
		font-size: 14px;
		font-weight: 600;
	}

	&__elm-select {
		position: relative;
	}

	&__elm-select-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px;
		width: 45px;
		margin-right: 10px;
		border-radius: 12px;
		border: 1px solid rgb(221, 221, 221);
		background: rgb(255, 255, 255);
		cursor: pointer;
	}

	&__elm-select-wrap-icon {
		transform: rotate(0.75turn);
	}

	&__elm-select-list {
		position: absolute;
		bottom: 46px;
		width: 73px;
		padding: 8px 0;
		background: rgb(255, 255, 255);
		border: 1px solid rgb(221, 221, 221);
		border-radius: 12px;
		max-height: 150px;
		overflow-y: auto;
		scrollbar-width: thin;
	}

	&__elm-select-list-item {
		padding: 6px 12px;
		cursor: pointer;
	}

	&__elm-select-list-item_current {
		padding: 6px 12px;
		cursor: pointer;
		background: rgb(236, 236, 236);
		border-radius: 4px;
	}

	&__elm-select-list-item:hover {
		background: rgb(225, 225, 225);
		border-radius: 4px;
	}
}
</style>
